import React from "react";
import brokerage from '../images/home/brokerage_icon.png'
import rent from '../images/home/rent_icon.png'
import approval from '../images/home/approval_icon.png'
import liaison from '../images/home/liaison_icon.png'
import registration from '../images/home/registration_icon.png'
import essential from '../images/home/essential_icon.png'

function FeaturedServices(){

    const fservices = [
    
        {
            src: brokerage,
            alt: "brokerage_icon",
            heading: "Brokerage",
            sub1: "Buying & Selling of Plots",
            sub2: "Apartments",
            sub3: "Villas",
            sub4: "Indivudual Homes",
            sub5: "Commercial Properties"
        },
        {
            src: rent,
            alt: "rent & lease_icon",
            heading: "Rent & Lease",
            sub1: "Retail stores",
            sub2: "Offices",
            sub3: "Commercial centers",
            sub4: "Apartments",
            sub5: "Warehouses",
        },
        {
            src : approval,
            alt: "approval_icon",
            heading: "Approval",
            sub1: "DTCP, LPA, Corporation & Panchayath approvals",
            sub2: "Building plan",
            sub3: "Indivudual homes",
            sub4: "Plot layouts",
            sub5: "Land use conversions",
            sub6: "Subdivision",
            sub7: "Regularization of Plots",
        },
        {
            src: liaison,
            alt: "liaison_icon",
            heading: "Liaison",
            sub1: "Legal Opinion",
            sub2: "Due Diligence",
            sub3: "EC",
            sub4: "VLT",
            sub5: "Feasibility Reports",
        },
        {
            src : registration,
            alt : "registration_icon",
            heading: "Registration",
            sub1: "Agreement drafts",
            sub2: "Sale Deed drafts",
            sub3: "POA drafts",    
            sub4: "MOD drafts",
        },
        {
            src: essential,
            alt: "essential_icon",
            heading: "Essential",
            sub1: "Patta/Chitta transfer",
            sub2: "Property Name transfer",
            sub3: "EB/Water Name transfer",
            sub4: "Tax assessments"
        }
    ];
    
    return (
        <>

            <div className="max-w-6xl mx-auto my-16" id="services">
                <h1 className="subheading !font-noto" data-aos="fade-up">Our Featured Services</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[23px]'/>


                <div className="mx-auto grid justify-center sm:grid-cols-2  xl:grid-cols-3 xl:gap-x-[35px] gap-y-[49px] mt-16"  data-aos="fade-up" data-aos-duration="1000">
                    {fservices.map((items)=> {
                        return (
                            <div className="bg-card-grey w-[340px]  lg:w-[382px] h-[465px] p-12  lg:p-[36px] mx-auto transition duration-300 hover:-translate-y-10 cursor-pointer" data-aos="fade-up">
                                <img className="w-[40px] h-[40px] mt-2" src={items.src} alt={items.alt} />
                                <h1 className="font-noto text-[32px] leading-[40px] font-bold mb-[30px] mt-[40px]">{items.heading}</h1>

                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub2}</p>
                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub1}</p>
                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub3}</p>
                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub4}</p>
                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub5}</p>
                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub6}</p>
                                <p className="font-alibaba  text-[20px] font-normal leading-[30.5px] tracking-[0.5px] text-[#5F5D5E] pb-[1px]">{items.sub7}</p>

                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default FeaturedServices